import { addDays, addMonths, format } from 'date-fns';

/**
 * Calculate payment due date based on transaction date and vendor's net terms
 * @param transactionDate - The date of the transaction
 * @param netTerms - The vendor's NET payment terms (10, 30, 60, 90, etc.)
 * @returns Formatted payment due date string (YYYY-MM-DD HH:mm:ss)
 */
export const calculatePaymentDueDate = (
  transactionDate: Date,
  netTerms: number | undefined | null,
): string => {
  if (!netTerms || netTerms <= 0) {
    return '';
  }

  let dueDate: Date;

  // Special handling for NET 10: 10th of the following month
  if (netTerms === 10) {
    const nextMonth = addMonths(transactionDate, 1);
    dueDate = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), 10);
  } else {
    // For other terms (30, 60, 90, etc.), add the specified number of days
    dueDate = addDays(transactionDate, netTerms);
  }

  return format(dueDate, 'yyyy-MM-dd HH:mm:ss');
};

// Note: getPaymentTermsDisplayText is now in constants/paymentTerms.ts

/**
 * Parse payment due date string to Date object
 * @param paymentDueDate - Payment due date string
 * @returns Date object or null if invalid
 */
export const parsePaymentDueDate = (paymentDueDate: string): Date | null => {
  if (!paymentDueDate) return null;

  try {
    // Handle both 'YYYY-MM-DD HH:mm:ss' and 'YYYY-MM-DD' formats
    const date = new Date(paymentDueDate.replace(' ', 'T'));
    return isNaN(date.getTime()) ? null : date;
  } catch {
    return null;
  }
};
